"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expandOrderLines = void 0;
/* eslint-disable @typescript-eslint/no-inferrable-types */
const dayjs = require("dayjs");
const uuid_1 = require("uuid");
const orders_1 = require("../orders");
const getCompulsoryDinners_1 = require("../hotel/getCompulsoryDinners");
const handleHotel = ({ items, item, latest_version, newItems, include_extras, processTransferLine, findLinkedTransferLine, }) => {
    if (latest_version.start_date === latest_version.end_date)
        return;
    const config = latest_version.config;
    const startDate = new Date(latest_version.start_date);
    const endDate = new Date(latest_version.end_date);
    const days = Math.round((endDate.getTime() - startDate.getTime()) / 86400000 + 1);
    const dinners = (0, getCompulsoryDinners_1.getCompulsoryDinners)(config);
    if (dinners) {
        for (let i = 0; i < dinners.length; i++) {
            const dinner = dinners[i];
            newItems.push({
                id: (0, uuid_1.v4)(),
                start_date: dinner.date,
                end_date: dinner.date,
                type: "DINNER",
                action: "COMPULSORY_DINNER",
                order_weight: 90,
                leg_number: item.leg_number,
                title: `Compulsory ${dinner.name}`,
                region_id: latest_version.region_id,
                region: latest_version.regions,
                supplier_id: config.supplier?.id || "",
                status: latest_version.status,
                linked_line_id: item.id, // Add linked_line_id
            });
        }
    }
    for (let i = 0; i < days; i++) {
        const isFirst = i === 0;
        const isLast = i === days - 1;
        const currentDate = dayjs(startDate).add(i, "day").format("YYYY-MM-DD");
        if (isFirst) {
            const linked_transfer_line = findLinkedTransferLine(item, currentDate);
            // if there is a hotel transfer straight from the airport then we can assume its before a round of golf on that day so set to 49
            let is_direct_transfer = false;
            if (linked_transfer_line) {
                if (!linked_transfer_line.versions)
                    return;
                const transfer_version = (0, orders_1.getLatestOrderLineVersion)(linked_transfer_line.versions);
                if (transfer_version) {
                    const transfer_config = transfer_version.config;
                    is_direct_transfer =
                        transfer_config?.transfer_legs?.outbound?.from_type === "Airport";
                }
            }
            processTransferLine(item, linked_transfer_line, latest_version, currentDate, is_direct_transfer ? 49 : 51);
            newItems.push({
                ...item,
                region_id: latest_version.region_id,
                region: latest_version.regions,
                order_weight: is_direct_transfer ? 49 : 51,
            });
        }
        if (!isFirst && !isLast && include_extras) {
            newItems.push({
                id: (0, uuid_1.v4)(),
                start_date: currentDate,
                end_date: currentDate,
                type: item.type,
                action: "HOTEL_OVERNIGHT",
                order_weight: 99,
                leg_number: item.leg_number,
                title: `Overnight at ${config.where_when_who.hotel?.name?.en} (Night ${i + 1} of ${days - 1})`,
                region_id: latest_version.region_id,
                region: latest_version.regions,
                supplier_id: config.supplier?.id || "",
                status: latest_version.status,
                linked_line_id: item.id, // Add linked_line_id
            });
        }
        if (isLast && include_extras) {
            const linked_transfer_line = findLinkedTransferLine(item, currentDate);
            // is there a transfer for this day which is a return transfer from the hotel
            const is_return_transfer = items.some((line) => {
                if (!line.versions)
                    return false;
                const lv = (0, orders_1.getLatestOrderLineVersion)(line.versions);
                if (!lv)
                    return false;
                return (line.type === "TRANSFER" &&
                    lv.start_date === currentDate &&
                    lv.config?.where_when_who?.type === "RETURN" &&
                    lv.config.transfer_legs.outbound?.from_area ===
                        config.where_when_who.hotel?.id);
            });
            newItems.push({
                id: (0, uuid_1.v4)(),
                start_date: currentDate,
                end_date: currentDate,
                type: item.type,
                action: "HOTEL_CHECK_OUT",
                order_weight: is_return_transfer ? 51 : 1,
                leg_number: item.leg_number,
                title: `Check-out from ${config.where_when_who.hotel?.name?.en} (by ${config.where_when_who.hotel.check_out_time})`,
                region_id: latest_version.region_id,
                region: latest_version.regions,
                supplier_id: config.supplier?.id || "",
                status: latest_version.status,
                linked_line_id: item.id, // Add linked_line_id
            });
            processTransferLine(item, linked_transfer_line, latest_version, currentDate, is_return_transfer ? 51 : 11);
        }
    }
};
const handleGolf = ({ items, item, latest_version, newItems, include_extras, processTransferLine, findLinkedTransferLine, }) => {
    const linked_transfer_line = findLinkedTransferLine(item);
    processTransferLine(item, linked_transfer_line, latest_version, latest_version.start_date, 50);
    newItems.push({
        ...item,
        region_id: latest_version.region_id,
        region: latest_version.regions,
        order_weight: 50,
    });
    if (linked_transfer_line && include_extras) {
        if (!linked_transfer_line.versions)
            return;
        const transfer_version = (0, orders_1.getLatestOrderLineVersion)(linked_transfer_line.versions);
        if (!transfer_version)
            return;
        const config = transfer_version.config;
        if (config.where_when_who.type !== "RETURN" &&
            config?.transfer_legs?.outbound?.from_type === "Airport") {
            newItems.push({
                id: (0, uuid_1.v4)(),
                title: `Arrival at ${config?.transfer_legs?.outbound?.from_name}`,
                start_date: transfer_version.end_date,
                status: transfer_version.status,
                supplier_id: config?.supplier?.id,
                region_id: transfer_version.region_id,
                region: transfer_version.regions,
                type: "FLIGHT",
                action: "ARRIVAL_TRANSFER",
                end_date: transfer_version.end_date,
                order_weight: 49,
                leg_number: linked_transfer_line.leg_number,
                linked_line_id: linked_transfer_line.id, // Add linked_line_id
            });
        }
        if (config.where_when_who.type !== "ONE_WAY") {
            newItems.push({
                id: (0, uuid_1.v4)(),
                title: config.where_when_who.type === "RETURN"
                    ? `Return journey to ${config?.transfer_legs?.inbound?.to_name}`
                    : `Onward journey to ${config?.transfer_legs?.inbound?.to_name}`,
                start_date: transfer_version.start_date,
                status: transfer_version.status,
                supplier_id: config?.supplier?.id,
                region_id: transfer_version.region_id,
                region: transfer_version.regions,
                type: "TRANSFER",
                action: config.where_when_who.type === "RETURN"
                    ? "RETURN_TRANSFER"
                    : "ONWARD_TRANSFER",
                end_date: transfer_version.end_date,
                order_weight: 50,
                leg_number: linked_transfer_line.leg_number,
                linked_line_id: linked_transfer_line.id, // Add linked_line_id
            });
            if (config.where_when_who.type !== "RETURN" &&
                config?.transfer_legs?.inbound?.to_type === "Airport") {
                newItems.push({
                    id: (0, uuid_1.v4)(),
                    title: `Departure from ${config?.transfer_legs?.inbound?.to_name}`,
                    start_date: transfer_version.end_date,
                    status: transfer_version.status,
                    supplier_id: config?.supplier?.id,
                    region_id: transfer_version.region_id,
                    region: transfer_version.regions,
                    type: "FLIGHT",
                    action: "DEPARTURE_TRANSFER",
                    end_date: transfer_version.end_date,
                    order_weight: 50.1,
                    leg_number: linked_transfer_line.leg_number,
                    linked_line_id: linked_transfer_line.id, // Add linked_line_id
                });
            }
        }
    }
};
const handleTransfer = ({ items, item, latest_version, newItems, include_extras, }) => {
    if ((latest_version.linked_line_id === null && include_extras) ||
        !include_extras) {
        const transfer_config = latest_version.config;
        const airport_transfer = transfer_config.where_when_who.date
            ? getAirportSummaryItem(transfer_config.where_when_who.date, 53, transfer_config, item)
            : null;
        if (airport_transfer && airport_transfer.action === "ARRIVAL_FLIGHT") {
            newItems.push({
                ...airport_transfer,
                region_id: latest_version.region_id,
                region: latest_version.regions,
            });
        }
        newItems.push({
            ...item,
            region_id: latest_version.region_id,
            region: latest_version.regions,
            order_weight: 53,
        });
        if (airport_transfer && airport_transfer.action === "DEPARTURE_FLIGHT") {
            newItems.push({
                ...airport_transfer,
                region_id: latest_version.region_id,
                region: latest_version.regions,
            });
        }
    }
};
const handleExcursionItem = ({ items, item, latest_version, newItems, }) => {
    newItems.push({
        ...item,
        region_id: latest_version.region_id,
        region: latest_version.regions,
        order_weight: 52,
    });
};
const handleCustomItem = ({ items, item, latest_version, newItems, }) => {
    newItems.push({
        ...item,
        region_id: latest_version.region_id,
        region: latest_version.regions,
        order_weight: 54,
    });
};
const getAirportTransferData = (config) => {
    const is_inbound_airport_transfer = config.transfer_legs.outbound.from_type === "Airport";
    const is_outbound_airport_transfer = config.transfer_legs.inbound.to_type === "Airport";
    const is_airport_transfer = is_inbound_airport_transfer ||
        is_outbound_airport_transfer ||
        config.transfer_legs.outbound.to_type === "Airport" ||
        config.transfer_legs.inbound.from_type === "Airport";
    return is_airport_transfer
        ? {
            inbound: is_inbound_airport_transfer,
            outbound: is_outbound_airport_transfer,
        }
        : null;
};
const getAirportSummaryItem = (date, weight, transfer_config, transfer_line // Add transfer_line_id parameter
) => {
    const airport_transfer = getAirportTransferData(transfer_config);
    if (!airport_transfer)
        return null;
    const arrival_data = transfer_config?.transfer_legs?.outbound
        .from_details;
    const departure_data = transfer_config?.transfer_legs?.outbound
        .to_details;
    const formatFlightInfo = (data) => data?.flight_number
        ? `(${data.flight_number}${data.flight_time ? ` / ${data.flight_time}` : ""})`
        : "(Flight info TBC)";
    const is_custom = transfer_config?.where_when_who?.type === "CUSTOM";
    if (!is_custom) {
        return {
            id: (0, uuid_1.v4)(),
            start_date: dayjs(date).format("YYYY-MM-DD"),
            end_date: dayjs(date).format("YYYY-MM-DD"),
            type: "FLIGHT",
            action: airport_transfer.inbound ? "ARRIVAL_FLIGHT" : "DEPARTURE_FLIGHT",
            order_weight: weight,
            title: airport_transfer.inbound
                ? `Arrival at ${transfer_config?.transfer_legs?.outbound?.from_name} ${formatFlightInfo(arrival_data)}`
                : `Departure from ${is_custom
                    ? transfer_config?.transfer_legs?.inbound?.to_name
                    : transfer_config?.transfer_legs?.outbound?.to_name} ${formatFlightInfo(departure_data)}`,
            leg_number: transfer_line.leg_number,
            linked_line_id: transfer_line.id,
            supplier_id: transfer_config.supplier?.id || "",
            status: null,
        };
    }
    return null;
};
const expandOrderLines = (items, include_extras = true) => {
    const newItems = [];
    const processTransferLine = (item, linked_transfer_line, latest_version, date, weight = 1) => {
        if (linked_transfer_line?.versions && include_extras) {
            const transfer_version = (0, orders_1.getLatestOrderLineVersion)(linked_transfer_line.versions);
            if (!transfer_version)
                return;
            const transfer_config = transfer_version.config;
            const airport_transfer = getAirportSummaryItem(date, weight, transfer_config, linked_transfer_line);
            if (airport_transfer && airport_transfer.action === "ARRIVAL_FLIGHT") {
                newItems.push({
                    ...airport_transfer,
                    region_id: transfer_version.region_id,
                    region: transfer_version.regions,
                });
            }
            newItems.push({
                ...linked_transfer_line,
                region_id: transfer_version.region_id,
                region: transfer_version.regions,
                order_weight: weight,
            });
            if (airport_transfer && airport_transfer.action === "DEPARTURE_FLIGHT") {
                newItems.push({
                    ...airport_transfer,
                    region_id: transfer_version.region_id,
                    region: transfer_version.regions,
                });
            }
        }
    };
    const findLinkedTransferLine = (item, date) => {
        return items.find((line) => {
            if (!line.versions)
                return false;
            const latest_version = (0, orders_1.getLatestOrderLineVersion)(line.versions);
            if (!latest_version)
                return false;
            const transfer_config = latest_version.config;
            return date
                ? latest_version?.linked_line_id === item.id &&
                    transfer_config.where_when_who.date === date
                : latest_version?.linked_line_id === item.id;
        });
    };
    items.forEach((item) => {
        if (!item.versions)
            return;
        const latest_version = (0, orders_1.getLatestOrderLineVersion)(item.versions);
        if (!latest_version)
            return;
        const context = {
            items: items,
            item,
            latest_version,
            newItems,
            include_extras,
            processTransferLine,
            findLinkedTransferLine,
        };
        switch (item.type) {
            case "HOTEL":
                handleHotel(context);
                break;
            case "GOLF":
                handleGolf(context);
                break;
            case "TRANSFER":
                handleTransfer(context);
                break;
            case "EXCURSION":
                handleExcursionItem(context);
                break;
            case "CUSTOM":
                handleCustomItem(context);
                break;
        }
    });
    return newItems;
};
exports.expandOrderLines = expandOrderLines;
